import initSlickWithArrowEvent from "../../components/slick-utils";

function initShopProductCategoryCarouselCategorySlider(slider) {
    const slick = initSlickWithArrowEvent(
        $(slider),
        {
            dots: false,
            dotsClass: 'slick-dots',
            prevArrow: '<span class="slide-arrow prev">Prev</span>',
            nextArrow: '<span class="slide-arrow next">Next</span>',
            autoplay: false,
            infinite: false,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ]
        }
    );
}

function observeShopProductCategoryCarouselCategorySlider() {
    // IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initShopProductCategoryCarouselCategorySlider(entry.target);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    document.querySelectorAll('.maier-wrapper-shop-product-category-carousel .maier-carousel-list').forEach(slider => intersectionObserver.observe(slider));

    // MutationObserver
    const mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length >= 1) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    if (undefined !== mutation.addedNodes[i].localName) {
                        mutation.addedNodes[i].querySelectorAll('.maier-wrapper-shop-product-category-carousel .maier-carousel-list').forEach(slider => initShopProductCategoryCarouselCategorySlider(slider));
                    }
                }
                ;
            }
        });
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
}

function setupMaierCarouselCategory() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            observeShopProductCategoryCarouselCategorySlider();
        })
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMaierCarouselCategory);
} else {
    setupMaierCarouselCategory();
}